import createReactComponent from '../createReactComponent';
export default createReactComponent('multiplier-1x', 'IconMultiplier1x', [
  ['path', { d: 'M9 16v-8l-2 2', key: 'svg-0' }],
  ['path', { d: 'M13 16l4 -4', key: 'svg-1' }],
  ['path', { d: 'M17 16l-4 -4', key: 'svg-2' }],
]);
